module.exports = __webpack_public_path__ + "img/logo-bai.c8fb2719.png";